/**
 * Employee Web — `/me/shifts` route.
 *
 * Mounts <MyShiftsPage>; breadcrumb resolves via the new `me-shifts` namespace.
 * No search params today — the page reads the next 30-day window by default
 * and surfaces validity-window metadata for each assignment.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { MyShiftsPage } from "../features/me/shifts/MyShiftsPage";

export const Route = createFileRoute("/_auth/me/shifts")({
  staticData: { breadcrumb: { labelKey: "me-shifts:page.title" } },
  component: MyShiftsRoute,
});

function MyShiftsRoute(): JSX.Element {
  return <MyShiftsPage />;
}
